

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';

// layout 
import AppLayout from '../../../layouts/AppLayout/AppLayout';

// section content 
import { NioSection } from '../../../components';
import CallToAction from '../../../components/PageComponents/SectionComponents/CallToAction/CallToAction';

function Index() {
  return (
    <AppLayout variant={2} title="Terms and Conditions">

      {/* Terms Section Start */}
      <NioSection className="pt-120 pt-lg-180" masks={["blur-1 left top", "blur-1 right bottom"]}>
        <div className="nl-block-head md">
          <div className="nl-section-head pb-0">
            <nav>
              <ol className="breadcrumb mb-3 mb-md-4">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
              </ol>
            </nav>
            <h2>Privacy Policy</h2>
          </div>
          <hr className="mt-5 mb-0" />
        </div>
        <NioSection.Content>
          <Row className="pt-3">
            {/* <Col lg="1"> */}
              {/* <div className="nl-entry-sidebar">
                <ul className="nl-list-link nl-list-link-page flush">
                  <li className="active">
                    <Link to="#" className="fs-7">Terms & Conditions</Link>
                  </li>
                  <li className="active">
                    <Link to="#" className="fs-7">Privacy Policy</Link>
                  </li>
                </ul>
              </div> */}
            {/* </Col> */}
            <Col lg="12">
            <div className="nl-entry-wrap pt-3 ps-lg-5">
                <div className="nl-entry">
                  {/* <div className="pb-5">
                    <h5>Terms and Conditions for ZiloChat</h5>
                    <p className="fs-7 text-dark">Welcome to ZiloChat, a Software as a Service (SaaS) platform designed for e-commerce businesses. By accessing or using our services, including AI-powered conversational tools, you agree to comply with and be bound by the following terms and conditions. Please read them carefully. If you do not agree with these terms, please refrain from using our platform.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>1. Definitions</strong></p>
                    <ul className="fs-7 text-dark">
                      <li><strong>"ZiloChat"</strong> refers to our SaaS platform, its website, and associated services.</li>
                      <li><strong>"User"</strong> refers to any individual or entity using ZiloChat.</li>
                      <li><strong>"Services"</strong> refers to the features and functionalities provided by ZiloChat, including AI-powered tools.</li>
                      <li><strong>"WhatsApp API"</strong> refers to the application programming interface provided by Meta and integrated into ZiloChat for conversational AI capabilities.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>2. Acceptance of Terms</strong></p>
                    <p className="fs-7 text-dark">By registering for, accessing, or using ZiloChat, you confirm that you have read, understood, and agreed to these Terms and Conditions. You also affirm that you are at least 18 years old or have the legal capacity to enter into these agreements.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>3. Scope of Services</strong></p>
                    <p className="fs-7 text-dark">ZiloChat provides tools to manage various aspects of e-commerce, including but not limited to:</p>
                    <ul className="fs-7 text-dark">
                      <li>Customer and supplier management</li>
                      <li>Order and delivery tracking</li>
                      <li>Financial management and reporting</li>
                      <li>Marketing campaigns</li>
                      <li>Inventory and warehouse management</li>
                      <li>AI-powered conversational tools using WhatsApp API for:</li>
                      <ul>
                        <li>Processing orders</li>
                        <li>Providing product information</li>
                      </ul>
                    </ul>
                    <p className="fs-7 text-dark">The features and functionalities are subject to change, enhancement, or discontinuation at ZiloChat's sole discretion.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>4. WhatsApp API Integration</strong></p>
                    <p className="fs-7 text-dark">ZiloChat uses the WhatsApp Business API provided by Meta to enable AI-driven conversations for users. By utilizing this feature, you agree to the following:</p>
                    <p className="fs-7 text-dark"><strong>4.1 Account Registration and Approval</strong></p>
                    <ul className="fs-7 text-dark">
                        <li>Users must register for a WhatsApp Business API account and complete WhatsApp's business verification process.</li>
                        <li>ZiloChat assists in integration but is not responsible for approval decisions made by Meta.</li>
                    </ul>
                    <p className="fs-7 text-dark"><strong>4.2 Compliance with Laws</strong></p>
                    <ul className="fs-7 text-dark">
                        <li>Users must comply with all applicable laws and regulations, including data protection and privacy laws, such as obtaining customer consent for communications.</li>
                        <li>Users are required to maintain accurate business information in their WhatsApp Business profile.</li>
                    </ul> 
                    <p className="fs-7 text-dark"><strong>4.3 Use Cases and Message Guidelines</strong></p>
                    <ul className="fs-7 text-dark">
                        <li>Users may use the WhatsApp Business API for approved purposes such as customer support and transactional notifications.</li>
                        <li>Promotional messaging is restricted. Users must follow WhatsApp's Business and Commerce Policies regarding the types of permissible messages.</li>
                        <li>Initiation of customer contact must comply with WhatsApp's opt-in requirements.</li>
                    </ul>
                    <p className="fs-7 text-dark"><strong>4.4 Opt-In and Opt-Out Requirements</strong></p>
                    <ul className="fs-7 text-dark">
                        <li>Users must ensure that all recipients have opted in to receive messages.</li>
                        <li>Customers must be provided with a clear and easy way to opt-out or block future messages.</li>
                    </ul>
                    <p className="fs-7 text-dark"><strong>4.5 Message Quality</strong></p>
                    <ul className="fs-7 text-dark">
                        <li>•	All messages must be clear, relevant, and useful to the recipient. Low-quality messages or violations of WhatsApp's guidelines may result in API access restrictions.</li>
                    </ul>
                    <p className="fs-7 text-dark"><strong>4.6 Data Privacy and Security</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>Users are responsible for secure storage and processing of customer data.</li>
                      <li>ZiloChat and its users must not share customer data with unauthorized parties or use it for purposes other than agreed upon by the customer.</li>
                      <li>All communications via WhatsApp are subject to Meta's data processing terms.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>5. User Responsibilities</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>Users must ensure that all interactions via the WhatsApp API comply with applicable laws, including but not limited to customer consent for communications.</li>
                      <li>Users are responsible for the accuracy of product and order information provided through the platform.</li>
                      <li>Users must not misuse the WhatsApp API integration for spam, unsolicited messages, or illegal activities.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>6. Data Privacy and Security</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>ZiloChat prioritizes data security and complies with relevant data protection regulations.</li>
                      <li>Messages and interactions via the WhatsApp API are processed in accordance with Meta's terms and our [Privacy Policy].</li>
                      <li>Users are responsible for obtaining any necessary consents from their customers before initiating communications via WhatsApp.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>7. Service Availability</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>ZiloChat strives to provide uninterrupted access but does not guarantee 100% uptime.</li>
                      <li>WhatsApp API integration relies on Meta's services.</li>
                      <li>Scheduled maintenance or unforeseen issues may result in temporary service disruptions.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>8. Limitation of Liability</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>ZiloChat and its WhatsApp API integration are provided "as is" and "as available" without warranties of any kind, either express or implied.</li>
                      <li>ZiloChat will not be liable for any indirect, incidental, special, or consequential damages arising from the use of our platform or WhatsApp API integration.</li>
                      <li>Our maximum liability for any claim will not exceed the total subscription fees paid by the user in the preceding 12 months.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>9. Termination</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>Users may terminate their subscription at any time by contacting support.</li>
                      <li>ZiloChat reserves the right to terminate accounts for violations of these terms, misuse of the platform, or WhatsApp API policies.</li>
                      <li>Upon termination, users will no longer have access to their data unless otherwise specified.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>10. Amendments</strong></p>
                    <ul className="fs-7 text-dark">
                      <li>ZiloChat reserves the right to modify these terms at any time. Users will be notified of significant changes via email or through the platform.</li>
                      <li>Continued use of ZiloChat after changes constitutes acceptance of the updated terms.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>11. Governing Law</strong></p>
                    <p className="fs-7 text-dark">These terms shall be governed by and construed in accordance with the laws of [Your Country]. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in [Your Jurisdiction].</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>12. Contact Information</strong></p>
                    <p className="fs-7 text-dark">If you have any questions or concerns regarding these terms, please contact us at:</p>
                    <p className="fs-7 text-dark"><strong>ZiloChat Support</strong><br />
                    Email: support@ZiloChat.com</p>
                  </div> */}
                  <div className="pb-5">
                    <h5>Privacy Policy for ZiloChat</h5>
                    <p className="fs-7 text-dark">At ZiloChat, your privacy is a top priority. This Privacy Policy outlines how we collect, use, store, and protect your personal information, including interactions enabled through our WhatsApp Business API integration for AI-powered conversations. By using ZiloChat, you agree to the practices described in this policy.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>1. Information We Collect</strong></p>
                    <p className="fs-7 text-dark">We collect the following types of information when you interact with ZiloChat:</p>
                      <p className="fs-7 text-dark"><strong>1.1 Account Information</strong></p>
                      <ul className="fs-7 text-dark">
                        <li>Name, email address, phone number, and business details when you register for an account.</li>
                      </ul>
                      <p className="fs-7 text-dark"><strong>1.2 Customer and Transaction Data</strong></p>
                      <ul className="fs-7 text-dark">
                        <li>Information related to your customers, including names, contact details, order history, and interactions.</li>
                      </ul>
                      <p className="fs-7 text-dark"><strong>1.3 Platform Usage Data</strong></p>
                      <ul className="fs-7 text-dark">
                        <li>Logs and data regarding your use of ZiloChat, such as accessed features, system usage metrics, and device information.</li>
                      </ul>
                      <p className="fs-7 text-dark"><strong>1.4 WhatsApp Conversations</strong></p>
                      <ul className="fs-7 text-dark">
                        <li>Message content and metadata (e.g., timestamps, message status) exchanged via WhatsApp Business API integration for AI-driven conversations.</li>
                      </ul>
                      <p className="fs-7 text-dark"><strong>1.5 Cookies and Tracking</strong></p>
                      <ul className="fs-7 text-dark">
                        <li>Data collected through cookies and tracking technologies to enhance your experience and analyze platform performance.</li>
                      </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>2. How We Use Your Information</strong></p>
                    <p className="fs-7 text-dark">We use your data to provide, improve, and personalize our services, including but not limited to:</p>
                    <ul className="fs-7 text-dark">
                      <li>Managing customer and order information</li>
                      <li>Generating reports and analytics</li>
                      <li>Facilitating AI-driven conversations via WhatsApp Business API</li>
                      <li>Communicating service updates, marketing content (with your consent), and support information</li>
                      <li>Ensuring compliance with legal and regulatory requirements</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>3. WhatsApp Business API Data Usage</strong></p>
                    <p className="fs-7 text-dark">ZiloChat uses the WhatsApp Business API provided by Meta to facilitate AI-powered conversations. This includes:</p>
                    <ul className="fs-7 text-dark">
                      <li>Processing customer inquiries, order placements, and product information requests</li>
                      <li>Ensuring compliance with Meta's policies and guidelines</li>
                      <li>Storing WhatsApp message metadata securely for performance analysis and troubleshooting</li>
                    </ul>
                    <p className="fs-7 text-dark"><em>Note: WhatsApp communication is subject to Meta's Privacy Policy.</em></p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>4. Data Sharing and Disclosure</strong></p>
                    <p className="fs-7 text-dark"><p className="fs-7 text-dark">We implement industry-standard security measures to protect your data, including:</p></p>
                    <ul className="fs-7 text-dark">
                      <li><strong>Service Providers</strong>: With trusted third-party vendors for hosting, data storage, and payment processing.</li>
                      <li><strong>Compliance</strong>: To comply with legal obligations, enforce terms, or protect the rights of ZiloChat, its users, or the public.</li>
                      <li><strong>Business Transfers</strong>: In the event of a merger, acquisition, or sale of assets.</li>
                    </ul>
                    <hr />
                    <p className="fs-7 text-dark"><strong>5. Data Security</strong></p>
                    <p className="fs-7 text-dark">We implement industry-standard security measures to protect your data, including:</p>
                    <ul className="fs-7 text-dark">
                      <li>Encryption of sensitive information during transmission</li>
                      <li>Secure server storage with restricted access</li>
                      <li>Regular security audits and vulnerability assessments</li>
                    </ul>
                    <p className="fs-7 text-dark">While we strive to ensure the safety of your data, no system is entirely secure. Users are responsible for maintaining the confidentiality of their account credentials.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>6. User Rights</strong></p>
                    <p className="fs-7 text-dark">You have the following rights concerning your data:</p>
                    <ul className="fs-7 text-dark">
                      <li><strong>Access and Rectification</strong>: View or update your personal information via your account settings.</li>
                      <li><strong>Data Portability</strong>: Request a copy of your data in a commonly used format.</li>
                      <li><strong>Deletion</strong>: Request the deletion of your account and associated data (subject to legal or operational requirements).</li>
                      <li><strong>Communication Preferences</strong>: Opt-out of marketing communications or specific notifications at any time.</li>
                    </ul>
                    <p className="fs-7 text-dark">To exercise these rights, contact us at <a href="mailto:privacy@ZiloChat.com">privacy@ZiloChat.com</a>.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>7. Retention of Data</strong></p>
                    <p className="fs-7 text-dark">We retain your data for as long as necessary to fulfill the purposes outlined in this policy or as required by law. When data is no longer needed, we securely it.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>8. WhatsApp Opt-In and Consent</strong></p>
                    <p className="fs-7 text-dark">Users of the WhatsApp integration must obtain explicit consent from their customers before initiating conversations.Customers must also have the ability to:</p>
                    <ul className="fs-7 text-dark">
                      <ul>
                        <li>Opt-out of receiving WhatsApp messages</li>
                        <li>Block further communications at their discretion</li>
                      </ul>
                    </ul>
                    <p className="fs-7 text-dark">ZiloChat provides tools to help you manage customer consent and preferences in compliance with WhatsApp's policies.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>9. Third-Party Links</strong></p>
                    <p className="fs-7 text-dark">Our platform may contain links to third-party websites or services. ZiloChat is not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>10. Children’s Privacy</strong></p>
                    <p className="fs-7 text-dark">ZiloChat is not directed at individuals under the age of 18, and we do not knowingly collect personal information from children.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>11. Updates to This Policy</strong></p>
                    <p className="fs-7 text-dark">We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Users will be notified of significant updates via email or through the platform. Continued use of ZiloChat after updates constitutes acceptance of the revised policy.</p>
                    <hr />
                    <p className="fs-7 text-dark"><strong>12. Contact Us</strong></p>
                    <p className="fs-7 text-dark">If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
                    <p className="fs-7 text-dark"><strong>ZiloChat Support</strong><br />
                    Email: <a href="mailto:privacy@ZiloChat.com"><strong>privacy@ZiloChat.com</strong></a></p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </NioSection.Content>
      </NioSection>
      {/* Terms Section End */}

      {/* CTA Section Start */}
      <NioSection>
        <NioSection.Content>
          <CallToAction />
        </NioSection.Content>
      </NioSection>
      {/* CTA Section End */}

    </AppLayout>
  );
}

export default Index;
